import React from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFCheckboxProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    isRequired?: boolean;
    name: string;
    rules?: unknown;
    disabled?: boolean;
    bodyStyle?: React.CSSProperties;
    onClick?: (event?: React.FormEvent<HTMLInputElement>) => void;
    onChange?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    defaultVal?: string;
    checked?: boolean;
}

const RHFCheckbox = (props: IRHFCheckboxProps) => {
    return (
        <div className="form-field" style={props.bodyStyle}>
            <input
                type="checkbox"
                name={props.name}
                id={props.name}
                ref={props.register ? props.register(props.rules) : undefined}
                className={`field-checkbox ${props.errors?.[props.name] ? 'error-field' : ''}`}
                disabled={props.disabled}
                onClick={props.onClick}
                onChange={props.onChange}
                style={!!props.disabled ? { verticalAlign: 'middle', cursor: 'not-allowed', ...props.style} : props.style}
                checked={props.checked}
            />
            <label htmlFor={props.name} style={props.labelStyle}>{props.label}</label>
            <br />
            {props.errors?.[props.name] && <p className="error-message">{props.errors?.[props.name]?.message}</p>}
        </div>
    );
};

export default RHFCheckbox;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFCheckBox.tsx